export default __webpack_public_path__ + "static/media/full-logo.e8a05296.svg";